export const ConfigData = [
  {
    id: "pk",
    name: "MIC ID",
    isShow: true,
    width: "200px",
    filter: false,
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "190px",
    filter: false,
  },
  {
    id: "group_str",
    name: "Department",
    isShow: true,
    width: "150px",
    filter: false,
  },
  {
    id: "created_by.name",
    name: "Created By",
    isShow: true,
    width: "150px",
    filter: false,
  },
  
  {
    id: "total_liked",
    name: "No. of Likes",
    isShow: true,
    width: "150px",
    filter: false,
  },
  {
    id: "created_by_sap",
    name: "SAP",
    isShow: true,
    width: "150px",
    filter: false,
  },
  {
    id: "status_str",
    name: "MIC Status",
    isShow: true,
    width: "150px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status","Visibility","View Details", "Delete"],
    permission: {
      ["Update Status"]: {
        id: "Update Status",
        permission: ["my_ideas.can_access_mic"],
      },
      ["Visibility"]: {
        id: "Visibility",
        permission: ["my_ideas.can_access_mic"],
      },
      ["View Details"]: {
        id: "View Details",
        permission: ["my_ideas.can_access_mic"],
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["my_ideas.limited_delete_ideas","my_ideas.delete_ideas"],
      },
    },
    
    
  },
];